import { tv } from "@/utils/tv.config";
import { VariantProps } from "tailwind-variants";

export const accordionItemClasses = tv({
  slots: {
    rootClasses:
      "Accordion_Item border border-gray-200 shadow-md rounded-xl mb-3 last:mb-0  bg-white  data-[open]:pb-4 data-[open]:border-secondary-light transition-all duration-300 ease-out",
    buttonClasses:
      "Accordion_Button group flex w-full cursor-pointer items-center justify-between gap-4  text-left font-medium focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-800 px-6 py-4",
    titleClasses: "Accordion_Title text-base font-semi-bold ",
    accordionPanel:
      "accordion-panel h-[var(--accordion-panel-height)] overflow-hidden text-base text-gray-600 transition-[height] duration-300 ease-out data-[ending-style]:h-0 data-[starting-style]:h-0 px-6",
    indicatorClasses:
      "Accordion_Indicator size-6 shrink-0 transition-all duration-300 ease-out group-data-[panel-open]:scale-110 group-data-[panel-open]:rotate-180 text-primary-main",
  },
  variants: {
    expanded: {
      true: {
        buttonClasses: "pb-3",
        indicatorClasses: "rotate-180",
        accordionPanel: "",
        rootClasses: "pb-6",
      },
    },
  },
});

export type AccordionItemVariantProps = VariantProps<
  typeof accordionItemClasses
>;
